import { render } from "./Medico.vue?vue&type=template&id=98e21416&scoped=true"
import script from "./Medico.vue?vue&type=script&lang=js"
export * from "./Medico.vue?vue&type=script&lang=js"

import "@/assets/css/listaRegistros.css?vue&type=style&index=0&id=98e21416&scoped=true&lang=css"
import "./Medico.vue?vue&type=style&index=1&id=98e21416&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e21416"]])

export default __exports__